import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { initPixel } from "@/lib/pixel";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let c = null;
    try { c = localStorage.getItem("cookie_consent"); } catch { /* noop */ }
    if (c === "granted") initPixel();
    else if (!c) setVisible(true);
  }, []);

  const decide = (granted) => {
    try { localStorage.setItem("cookie_consent", granted ? "granted" : "denied"); } catch { /* noop */ }
    setVisible(false);
    if (granted) initPixel();
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent"
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[100] rounded-xl bg-[#0E2A47] text-white shadow-2xl border border-white/10 p-5">
      <div className="flex items-start gap-3">
        <Cookie size={22} className="text-[#FF5625] shrink-0 mt-0.5" />
        <div className="text-sm leading-relaxed text-white/80">
          Usamos cookies propias y de terceros (Meta) para medir el uso y mejorar AuditReady. Puedes aceptarlas o seguir solo con las esenciales.
        </div>
      </div>
      <div className="flex gap-2 mt-4 justify-end">
        <Button data-testid="cookie-reject" variant="ghost"
          onClick={() => decide(false)}
          className="text-white/70 hover:text-white hover:bg-white/10">Solo esenciales</Button>
        <Button data-testid="cookie-accept"
          onClick={() => decide(true)}
          className="bg-[#FF5625] hover:bg-[#E0451A]">Aceptar cookies</Button>
      </div>
    </div>
  );
}
